import React from 'react';
import { ReactComponent as GraphicBase } from '~/assets/images/error-graphic-base.svg';
import { ReactComponent as GraphicTop } from '~/assets/images/error-graphic-top.svg';

const CalculationErrorMessage: React.FC = () => {
  return (
    <div>
      <h2 className="relative z-20 text-black font-display text-2xl mb-4">Berekening niet gelukt</h2>
      <p className="text-stone-700 text-balance mb-0">
        Helaas konden we jouw maximale hypotheek niet berekenen. Probeer het later opnieuw of neem contact op met een adviseur voor hulp.
      </p>
      <div className="-my-6">
        <div className="mx-auto lg:w-8/12 relative">
          <GraphicBase className="relative h-auto w-full fill-stone-500" />
          <GraphicTop className="absolute top-0 left-0 h-full w-full fill-tomato-500" />
        </div>
      </div>
    </div>
  );
};

export default CalculationErrorMessage;